<div class="no-data-wrapper">
  <mat-icon class="no-data-icon">web_asset_off</mat-icon>
  <span class="no-data-text">{{ 'common.no-data' | translate }}</span>
</div>
